import { Distributor } from "creso-core/api";
import { NoteListItem } from "creso-core/types";
import { useQueries } from "@tanstack/react-query";
import { useMemo } from "react";

export function useFamilyMemberNotes(clientIds: number[]) {
  const noteQueries = useQueries({
    queries: clientIds.map((clientId) => ({
      queryKey: ["family-member-notes-preview", clientId],
      queryFn: () => Distributor.getNotes({ clientId, page: 1 }),
      enabled: clientIds.length > 0,
    })),
  });

  const notes = useMemo(() => {
    return noteQueries
      .flatMap((query) => query.data?.results ?? [])
      .sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      ) as NoteListItem[];
  }, [noteQueries]);

  const isLoading = noteQueries.some((query) => query.isLoading);

  return { notes, isLoading };
}
